import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { EmptyComponent } from './empty/empty.component';
import { ErrorComponent } from './error/error.component';
import { LoginComponent } from './login/login.component';
import { NoPermissionComponent } from './no-permission/no-permission.component';

@NgModule({
  declarations: [
    LoginComponent,
    ErrorComponent,
    EmptyComponent,
    NoPermissionComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CardModule,
    InputTextModule,
    ButtonModule,
    TranslateModule,
  ],
  exports: [
    LoginComponent,
    ErrorComponent,
    EmptyComponent,
    NoPermissionComponent,
  ],
})
export class BuildinPageModule {}
